import ReactDOM from 'react-dom';
import usePortal from '../../hooks/portal';

const NotificationBarPortal = ({ children }) => {
  const target = usePortal('NotificationPortal');
  return ReactDOM.createPortal(children, target);
};

export default NotificationBarPortal;
